import { Helmet } from 'react-helmet';
import {
    Box,
    Button,
    Card,
    CardHeader,
    CardActions,
    CardContent,
    Chip,
    Container,
    Divider,
    Checkbox,
    Grid,
    Typography,
    Paper,
    TextField,
    Switch,
    FormGroup,
    FormControlLabel,
    MenuItem,
    Select,
    FormHelperText
} from '@mui/material';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import emtyData from "../../../../assets/images/emty-data.png";
import { Formik } from "formik";
import * as Yup from 'yup';
import DialogIcon from "../../../../components/kpi/DialogIcon";
import IdpService from "../../../../services/idp.service";
import adminService from "../../../../services/admin.service";
import scalingMasterService from "../../../../services/scalingMaster.service";
import { useFormik } from 'formik';
import * as yup from 'yup';
import * as Util from "../../../../services/global.service";
import { ReactComponent as Dropdown } from "../../../../assets/images/dropdown.svg";
import Icon from '@mui/material/Icon';
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import MessageDialog from "../../../../components/inbox/MessageDialog";
import { ReactComponent as PlusIcon } from "../../../../assets/icons/plus.svg";
import { ReactComponent as Delete } from "../../../../assets/icons/delete.svg";
import { set } from 'date-fns';
import { textAlign } from '@mui/system';

const styles = {
    path: {
        color: "#68717A",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    buttonFile: {
        position: "absolute",
        right: "1px",
        top: "1px",
        // bottom: "9px",
        background: "linear-gradient(0deg, #E5E9EC, #E5E9EC), #404349",
        borderLeft: "1px solid #CED4DA",
        "border-radius": "0px 4px 4px 0px",
        width: "100px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
    dropdowm: {
        position: "absolute",
        right: "20px",
        top: "40%",
        // bottom: "9px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },

};

const ScalingMasterCreate = (props) => {
    const { t } = useTranslation();

    useEffect(() => {
    }, []);
    // position: absolute; bottom: -24px
    const useStyles = makeStyles({
        iconContainer: {
            '& svg': {
                width: "45px",
                height: "45px"
            }
        },
        formTextField: {
            '& .MuiTextField-root': { m: 1, width: '25ch' },
        },
        fieldsetError: {
            '& div > fieldset': {
                "border-color": "#CC6058"
            }
        },
        disabled: {
            // '& .MuiFormControl-root': {
            background: "#FAFAFA",
            borderRadius: "4px",
            // },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                borderRadius: "4px",
                backgroundColor: "#FAFAFA"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            },
            '& div > input': {
                height: '8px',
                position: "relative"
            }
        },
        input: {
            '& div > input': {
                height: '7px',
                position: "relative"
            }
        },
        inputTopicDisabled: {
            // '& .MuiFormControl-root': {
            background: "#FAFAFA",
            borderRadius: "4px",
            // },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                borderRadius: "4px",
                backgroundColor: "#FAFAFA"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            },
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            '& div > input': {
                padding: "12px 14px",
                "font-size": "16px",
                height: '7px',
                position: "relative"
            }
        },
        inputTopic: {
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            '& div > textarea': {
                padding: "4.5px 14px",
                "font-size": "16px",
                height: '7px',
                position: "relative"
            }
        },
        inputTopicError: {
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            '& div > textarea': {
                padding: "4.5px 14px",
                "font-size": "16px",
                height: '8px',
                position: "relative"
            },
            '& fieldset': {
                "border-color": "#CC6058"
            }
        },
        inputValue: {
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            '& div > input': {
                height: '7px',
                position: "relative",
                textAlign: "center"
            }
        },
        inputValueError: {
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            '& div > input': {
                height: '7px',
                position: "relative",
                textAlign: "center"
            },
            '& fieldset': {
                "border-color": "#CC6058"
            }
        },
        disabledScale: {
            // '& .MuiFormControl-root': {
            background: "#FAFAFA",
            borderRadius: "4px",
            // },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                backgroundColor: "#FAFAFA"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            },
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            '& div > input': {
                padding: "12px 14px",
                "font-size": "16px",
                height: '7px',
                position: "relative"
            }
        },
        selectDisabled: {
            // '& .MuiFormControl-root': {
            background: "#FAFAFA",
            borderRadius: "4px",
            // },
            '&.Mui-selected': {
                '-webkit-text-fill-color': '#404349 !important',
                backgroundColor: "#FAFAFA !important"
            },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                backgroundColor: "#FAFAFA !important"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            },
            '& div ': {
                padding: "8.5px 14px"
            }
        },
        select: {
            '& div ': {
                padding: "8.5px 14px"
            }
        },
        selectError: {
            '& div ': {
                padding: "8.5px 14px"
            },
            '& fieldset': {
                "border-color": "#CC6058"
            }
        },
        inputError: {
            '& div > input': {
                color: "#CC6058",
                background: "#CC60581A",
                textAlign: "center",
                height: '6px',
                border: "1px solid #CC6058 !important",
                borderRadius: "4px"
            }
        },
        width50: {
            width: "calc(50% - 80px)",
            margin: "0 40px",
        },
        width100: {
            width: "calc(50% - 80px)",
            margin: "0 40px",
        },
        boxInput: {
            ".MuiFormControl-root": {
                "margin-top": "7px"
            }
        },
        fillGrey: {
            '& > path': {
                fill: "#D8D8D8 !important",
            },
            '& g > path': {
                fill: "#D8D8D8 !important",
            },
        },
        fillGreyStroke: {
            '& > path': {
                stroke: "#D8D8D8 !important"
            },
            '& g > path': {
                stroke: "#D8D8D8 !important"
            },
        },
    })
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    const classes = useStyles();
    let { serial } = useParams()
    const [ratingScale, setRatingScale] = React.useState([]);
    const [status, setStatus] = React.useState(true);
    const [onSubmit, setOnSubmit] = React.useState(false);
    const [checkCode, setCheckCode] = React.useState(false);
    const [allow_adjust, setAllow_adjust] = React.useState(true);
    const [scaleSelect, setScale] = React.useState([]);
    const [max, setMax] = React.useState(0);
    const [start, setStart] = React.useState(0);
    const [scaleUp, setScaleUp] = React.useState(1);
    const [edit, setEdit] = React.useState(true);
    const [save, setSave] = React.useState(false);
    const [errorText, seterrorText] = React.useState("");
    const [updateExists, setUpdateExists] = React.useState(false);
    const [defaults, setDefault] = React.useState(false);
    const [statusCheck, setStatusCheck] = React.useState(false);
    const [statusUse, setStatusUse] = React.useState(false);
    const [dataRemove, setDataRemove] = React.useState([]);
    const [format, setFormat] = React.useState(false);
    const handleStatus = () => {
        setStatus(!status)
    }

    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: "50px !important",
        height: "24px !important",
        padding: "0 !important",
        marginRight: "10px",
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: "4px 6px",
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(22px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#5DA196',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 1,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color:
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[600],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 1,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 16,
            height: 16,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#C0C0C0' : '#39393D',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
        "& .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track": {
            backgroundColor: "#D8D8D8!important"
        }
    }));
    const validationSchema = yup.object({
        code: yup.string().required(t('admin.inputForm.msgError.code')),
        name: yup.string().max(255).required(t('admin.inputForm.msgError.nameTH')),
        type: yup.string().max(255).required(t('admin.inputForm.msgError.nameTH')),
    });
    const formik = useFormik({
        initialValues: {
            code: '',
            name: '',
            description: '',
            type: '',
            ratingScale: [],
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            if (checkData() === true) {
                if (serial !== undefined && serial !== null) {
                    submit(values)
                } else {
                    adminService.checkCode("scale_master", values.code).then(
                        (response) => {
                            setCheckCode(response?.data?.is_exist)
                            if (response?.data?.is_exist === false) {
                                submit(values)
                            }
                        },
                    ).catch(() => {
                    })
                }
            }
        },
    });
    const checkData = () => {
        let findDataRatingScale = formik.values.ratingScale.length > 0 ? formik.values.ratingScale.filter((res) => res.value !== "") : []
        if (findDataRatingScale !== undefined) {
            if (formik.values.ratingScale.length > 0) {
                if (findDataRatingScale !== undefined && findDataRatingScale.length > 0 && findDataRatingScale.length === formik.values.ratingScale.length) {
                    return true;
                }
                return false;
            } else if (formik.values.ratingScale.length > 0 && findDataRatingScale !== undefined && findDataRatingScale.length > 0 && findDataRatingScale.length === formik.values.ratingScale.length) {
                return true;
            }
        }
        return false;
    }
    const checkDataOne = (data) => {
        let findData = data.filter((res) => res.value !== "")
        if (findData !== undefined && findData.length > 0 && findData.length === data.length) {
            return true;
        }
        return false;
    }

    const handleSubmit = () => {
        formik.submitForm()
        setOnSubmit(true)
    }
    const addRatingScale = () => {
        setRatingScale([...ratingScale, {}])
        formik.setFieldValue("ratingScale", [...formik.values.ratingScale, { id: "", level: "", value: "", descriptionEN: "", descriptionTH: "", add: true, remove: "" }])
    }
    // const formikChange = (val, field, subField, index, type) => {
    // let data = JSON.parse(JSON.stringify(formik.values))
    // data[field][index] = { ...formik.values[field][index], [subField]: "is_required" === subField ? !formik.values[field][index][subField] : val.target.value }
    // formik.setFieldValue(field, data[field])
    // }
    const formikChange = (val, field, subField, index,) => {
        let data = JSON.parse(JSON.stringify(formik.values))
        formik.setFieldValue(field, val.target.value)
        if (field === "type") {
            if (val.target.value !== undefined && val.target.value !== null && val.target.value !== "") {
                let datas = []
                for (let index = 0; index <= scaleSelect.length - 1; index++) {
                    if (val.target.value === scaleSelect[index].value) {
                        if (scaleSelect[index].max > 0) {
                            if (scaleSelect[index].start_with > 0) {
                                for (let idx = 1; idx <= scaleSelect[index].max; idx++) {
                                    datas.push({
                                        id: "",
                                        // level: "",
                                        value: "",
                                        descriptionEN: "",
                                        descriptionTH: "",
                                        edit: true
                                    })
                                }

                            } else {
                                for (let idx = 0; idx < scaleSelect[index].max; idx++) {
                                    datas.push({
                                        id: "",
                                        // level: "",
                                        value: "",
                                        descriptionEN: "",
                                        descriptionTH: "",
                                        edit: true
                                    })
                                }
                            }

                        } else {
                            datas.push({
                                id: "",
                                // level: "",
                                value: "",
                                descriptionEN: "",
                                descriptionTH: "",
                            })
                        }
                        setMax(scaleSelect[index].max)
                        setStart(scaleSelect[index].start_with)
                        setScaleUp(Number(scaleSelect[index].scale_up))
                        setFormat(scaleSelect[index].format)
                        setRatingScale(datas)
                        formik.setFieldValue("ratingScale", datas)
                    }
                }
            }
        }
    }
    const formikChangeScale = (val, field, subField, index,) => {
        let data = JSON.parse(JSON.stringify(formik.values))
        data[field][index] = { ...formik.values[field][index], [subField]: val.target.value }
        formik.setFieldValue(field, data[field])
    }
    const formikChangeNumber = (val, field, subField, index) => {
        const regex = /[^0-9]/g;
        const regexD = /[^0-9.]/g;
        const found = val.target.value.match(regexD);
        let indexof = val.target.value.indexOf(".")
        let lastIndexof = val.target.value.lastIndexOf(".")
        let dm = (val.target.value.length - 1) - lastIndexof
        if (found !== null || val.target.value === "." || indexof !== lastIndexof) {

        } else {
            let data = JSON.parse(JSON.stringify(formik.values))
            data[field][index] = { ...formik.values[field][index], [subField]: val.target.value }
            formik.setFieldValue(field, data[field])
        }
    }
    const formikDelete = (dataLoop, field, setData, index) => {
        let data = JSON.parse(JSON.stringify(formik.values))
        let dataShow = JSON.parse(JSON.stringify(dataLoop))
        let dataRemoves = data[field][index]
        data[field].splice(index, 1)
        dataShow.splice(index, 1)
        setData(dataShow)
        if (dataRemoves.add !== true) {
            setDataRemove([...dataRemove, dataRemoves])
        }
        formik.setFieldValue(field, data[field])
    }
    const handleCancel = () => {
        setDiscardDialog(true)
    }

    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const handleOpenFailedMessageDialog = (value) => {
        setFailedMessageDialog(true);
    };
    const handleCloseFailedMessageDialog = (value) => {
        setFailedMessageDialog(false);
    };
    const [discardDialog, setDiscardDialog] = React.useState(false);
    const handleDiscardDialog = (value) => {
        setDiscardDialog(value)
    };
    const handleDiscardChangeConfirm = () => {
        handleDiscardDialog(false)
        openDialog(false);
        navigate('/admin/scaling-master', { replace: false });
    };
    const [checkDialog, setCheckDialog] = React.useState(false);
    const handleCheckDialog = (value) => {
        setCheckDialog(value)
    };
    const handleCheckChangeConfirm = () => {
        handleCheckDialog(false)
        openDialog(false);
        setCheckDialog(false)
        setStatusCheck(false)
        for (let index = 0; index <= formik.values.ratingScale.length - 1; index++) {
            if (start === 1 && scaleUp === 1) {
                formik.values.ratingScale[index].level = '' + (index + start)
            } else if (start > 0) {
                formik.values.ratingScale[index].level = '' + ((index + 2) * scaleUp)
            } else {
                formik.values.ratingScale[index].level = '' + (index * scaleUp)
            }
        }
        if (serial !== undefined && serial !== null) {
            scalingMasterService.editScalingMaster(serial, {
                "id": serial,
                "code": formik.values.code,
                "name": formik.values.name,
                "format": format,
                "description": formik.values.description,
                "status": status === true ? "active" : "inactive",
                "scale_level": formik.values.ratingScale,
                "add": formik.values.ratingScale.filter((res) => res?.add === true),
                "remove": dataRemove,
                "is_update_exists": defaults,
                "type_value": formik.values.type
            }).then(
                (response) => {
                    openSuccessAddDialog(true)
                },
            ).catch(() => {
                seterrorText(t(`admin.label.scalingMasterEditFail`))
                handleOpenFailedMessageDialog(true)
            })
        } else {
            scalingMasterService.createScalingMaster({
                "id": "",
                "code": formik.values.code,
                "name": formik.values.name,
                "format": format,
                "description": formik.values.description,
                "status": status === true ? "active" : "inactive",
                // "scale_level": formik.values.ratingScale,
                "add": formik.values.ratingScale,
                "is_update_exists": defaults,
                "type_value": formik.values.type
            }).then(
                (response) => {
                    openSuccessAddDialog(true)
                },
            ).catch(() => {
                seterrorText(t(`admin.label.scalingMasterCreatedFail`))
                handleOpenFailedMessageDialog(true)
            })
        }

    };
    const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false);
    const [isAddDialogOpen, openDialog] = React.useState(false);
    const handleOpenDialog = (value) => {
        openDialog(true);
    };
    const handleDirect = () => {
        openSuccessAddDialog(false)
        navigate('/admin/scaling-master', { replace: false });
    }
    const submit = (data) => {
        for (let index = 0; index <= data.ratingScale.length - 1; index++) {
            if (start === 1 && scaleUp === 1) {
                data.ratingScale[index].level = '' + (index + start)
            } else if (start > 0) {
                data.ratingScale[index].level = '' + ((index + 2) * scaleUp)
            } else {
                data.ratingScale[index].level = '' + (index * scaleUp)
            }
        }
        if (statusUse) {
            setCheckDialog(true)
        } else {
            if (serial !== undefined && serial !== null) {
                scalingMasterService.editScalingMaster(serial, {
                    "id": serial,
                    "code": formik.values.code,
                    "name": formik.values.name,
                    "format": format,
                    "description": formik.values.description,
                    "status": status === true ? "active" : "inactive",
                    "scale_level": data?.ratingScale,
                    "add": data?.ratingScale.filter((res) => res?.add === true),
                    "remove": dataRemove,
                    "is_update_exists": defaults,
                    "type_value": formik.values.type
                }).then(
                    (response) => {
                        openSuccessAddDialog(true)
                    },
                ).catch(() => {
                    seterrorText(t(`admin.label.scalingMasterEditFail`))
                    handleOpenFailedMessageDialog(true)
                })
            } else {
                scalingMasterService.createScalingMaster({
                    "id": "",
                    "code": formik.values.code,
                    "name": formik.values.name,
                    "format": format,
                    "description": formik.values.description,
                    "status": status === true ? "active" : "inactive",
                    // "scale_level": data?.ratingScale,
                    "add": data?.ratingScale,
                    "is_update_exists": defaults,
                    "type_value": formik.values.type
                }).then(
                    (response) => {
                        openSuccessAddDialog(true)
                    },
                ).catch(() => {
                    seterrorText(t(`admin.label.scalingMasterCreatedFail`))
                    handleOpenFailedMessageDialog(true)
                })
            }
        }
    }
    useEffect(() => {
        if (save === false) {
            setSave(true)
        }
    }, [formik.values, status, defaults]);
    useEffect(() => {
        scalingMasterService.getDropdownType().then((rs) => {
            setScale(rs?.data?.types !== undefined ? rs?.data?.types : [])
        }).catch((err) => {

        })
    }, []);
    useEffect(() => {
        if (serial !== undefined && serial !== null) {
            scalingMasterService.getEditScalingMaster(serial).then((rs) => {
                formik.setFieldValue("code", rs?.data?.code)
                formik.setFieldValue("name", rs?.data?.name)
                formik.setFieldValue("description", rs?.data?.description)
                formik.setFieldValue("type", rs?.data?.type_value)
                formik.setFieldValue("ratingScale", rs?.data?.scale_level)
                setDefault(rs?.data?.is_update_exists)
                setRatingScale(rs?.data?.scale_level)
                setStatus(rs?.data?.status === "active" ? true : false)
                setEdit(rs?.data?.code)
                setSave(true)
                setUpdateExists(rs?.data?.is_update_exists)
                setStatusUse(rs?.data?.is_used)
                for (let index = 0; index <= scaleSelect.length - 1; index++) {
                    if (rs?.data?.type_value === scaleSelect[index].value) {
                        setMax(scaleSelect[index].max)
                        setStart(scaleSelect[index].start_with)
                        setScaleUp(Number(scaleSelect[index].scale_up))
                        setFormat(scaleSelect[index].format)
                    }
                }
            })
        }

    }, [scaleSelect]);
    useEffect(() => {
        if (checkCode === true) {
            setCheckCode(false)
        }
    }, [formik.values.code]);
    const onCheckDefault = () => {
        setDefault(!defaults)
    }
    // useEffect(() => {
    //     if (updateExists !== defaults) {
    //         setStatusCheck(true)
    //     } else {
    //         setStatusCheck(false)
    //     }
    // }, [defaults]);
    return (
        <>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/admin/scaling-master')}>{t('admin.label.scalingMaster')}</span> / <span style={styles.end} >{serial !== undefined ? t('admin.label.editScalingMaster') : t('admin.label.createScalingMaster')}</span></Typography>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} >
                            <Typography variant="h1" color="#404349" fontSize={36} lineHeight="53.82px" fontWeight="500">
                                {serial !== undefined ? t('admin.label.editScalingMaster') : t('admin.label.createScalingMaster')}
                            </Typography>
                        </Grid>
                        <Grid direction="column" sx={{}}
                            container item
                            justifyContent="center"
                            alignItems="center">
                            <Grid container item>
                                <Paper sx={{ padding: "40px 40px 20px", "box-shadow": " 0px 2px 10px rgba(0, 0, 0, 0.1)", "border-radius": "10px", width: '100%' }} classes={{ root: classes.error }}>
                                    <Box display="flex" sx={{ margin: "0 -40px", flexFlow: "row wrap" }}>
                                        <Box sx={{ width: "calc(50% - 80px)", position: "relative", margin: "0 40px", ".MuiFormControl-root": { "margin-top": "7px" }, ".MuiFormHelperText-root": { position: "absolute", bottom: "-23px" } }} >
                                            <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.code')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <TextField
                                                error={Boolean(formik.touched.code && formik.errors.code) === false ? checkCode === true ? true : false : true}
                                                fullWidth
                                                helperText={formik.touched.code && formik.errors.code}
                                                margin="normal"
                                                name="code"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.code}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                                placeholder={t('admin.inputForm.placeholder.code')}
                                                classes={{ root: serial !== undefined ? classes.disabled : allow_adjust === true ? classes.input : classes.disabled }}
                                                disabled={serial !== undefined ? true : allow_adjust === true ? false : true}
                                            />
                                            {Boolean(formik.touched.code && formik.errors.code) === false && checkCode === true ? (<FormHelperText error sx={{ marginTop: "-5px", marginRight: "14px", marginBottom: "8px", marginLeft: "14px" }}>{t('label.alreadyUsed')}</FormHelperText>) : <></>}
                                        </Box>
                                        <Box sx={{ width: "calc(50% - 80px)", margin: "0 40px", ".MuiFormControl-root": { "margin-top": "7px" } }}>
                                            <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.status')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <Box sx={{ "margin-top": "7px", height: "41px", display: "flex", "align-items": "center", ".MuiFormControlLabel-root .MuiFormControlLabel-label.Mui-disabled": { color: '#404349' } }}>
                                                <FormGroup >
                                                    <FormControlLabel
                                                        sx={{ m: 0, ".MuiTypography-root": { color: "#404349" } }}
                                                        control={<IOSSwitch checked={status} disabled={serial !== undefined ? statusUse === true ? true : false : false} onChange={() => handleStatus()} />}
                                                        label={status ? t('admin.inputForm.active') : t('admin.inputForm.inActive')}
                                                    // disabled
                                                    />
                                                </FormGroup>
                                                {/* <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{status ? t('admin.inputForm.active') : t('admin.inputForm.inActive')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography> */}
                                            </Box>
                                        </Box>
                                        <Box pt="17px" sx={{ width: "calc(100% - 80px)", margin: "0 40px", ".MuiFormControl-root": { "margin-top": "7px" }, ".MuiFormHelperText-root": { position: "absolute", bottom: "-23px" } }}>
                                            <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.name')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <TextField
                                                error={Boolean(formik.touched.name && formik.errors.name)}
                                                fullWidth
                                                helperText={formik.touched.name && formik.errors.name}
                                                margin="normal"
                                                name="name"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.name}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                                placeholder={t('admin.inputForm.placeholder.name')}
                                                disabled={serial !== undefined ? allow_adjust === true ? false : true : false}
                                                classes={{ root: serial !== undefined ? allow_adjust === true ? classes.input : classes.disabled : classes.input }}
                                            />
                                        </Box>
                                        <Box pt="17px" sx={{ width: "calc(100% - 80px)", margin: "0 40px", ".MuiFormControl-root": { "margin-top": "7px" } }}>
                                            <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.description')}</Typography>
                                            <TextField
                                                fullWidth
                                                margin="normal"
                                                name="description"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.description}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                                placeholder={t('admin.inputForm.placeholder.description')}
                                                disabled={serial !== undefined ? allow_adjust === true ? false : true : false}
                                                classes={{ root: serial !== undefined ? allow_adjust === true ? classes.input : classes.disabled : classes.input }}
                                            />
                                        </Box>
                                        <Box pt="17px" sx={{ width: "calc(100% - 80px)", margin: "0 40px", ".MuiFormControl-root": { "margin-top": "7px" } }}>
                                            <Typography mb="10px" variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.type')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <Select
                                                id="workload-select"
                                                inputlabelprops={{ shrink: false }}
                                                variant="outlined"
                                                size="small"
                                                className="white-bg"
                                                value={formik.values.type}
                                                onChange={e => formikChange(e, "type")}
                                                defaultValue=""
                                                displayEmpty
                                                placeholder={t('admin.inputForm.placeholder.type')}
                                                error={Boolean(formik.touched.type && formik.errors.type)}
                                                fullWidth
                                                helperText={formik.touched.type && formik.errors.type}
                                                name="type"
                                                classes={{ root: serial !== undefined ? classes.selectDisabled : allow_adjust === true ? classes.select : classes.selectDisabled }}
                                                disabled={serial !== undefined ? true : allow_adjust === true ? false : true}
                                            >
                                                <MenuItem disabled value="">
                                                    <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.type')}</Typography>
                                                </MenuItem>
                                                {
                                                    scaleSelect?.length > 0 ?
                                                        scaleSelect.map(item => {
                                                            return (
                                                                <MenuItem value={item.value} key={item.value}>
                                                                    {item.name}
                                                                </MenuItem>
                                                            )
                                                        })

                                                        : <MenuItem value="">
                                                            ---{t('label.notFund')}---
                                                        </MenuItem>
                                                }
                                            </Select>
                                            {formik.touched.type && formik.errors.type ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.type} </FormHelperText>) : <></>}
                                        </Box>
                                        {formik.values.type !== undefined && formik.values.type !== null && formik.values.type !== "" ?
                                            <Box sx={{ width: "calc(100% - 80px)", margin: "0 40px" }} pt="20px" >
                                                <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.label.ratingScale')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                                <Box sx={{ position: "relative" }}>
                                                    <Box mt="10px" sx={{ border: onSubmit === true ? ratingScale.length === 0 ? "1px solid #CC6058" : "1px solid #CED4DA" : "1px solid #CED4DA", "box-sizing": "border-box", "border-radius": "4px", padding: "17px 29px" }}>
                                                        <Box sx={{ display: "flex", "align-items": "center", "justify-content": "space-between" }}>
                                                            <Typography fontWeight="500" color="#404349" fontSize={16} lineHeight="23.92px" display="flex">{t('admin.label.manageRatingScale')}</Typography>
                                                            {statusUse || max === ratingScale.length || formik.values.type === "scale1_5_decimal" ?
                                                                <Box sx={{ cursor: "default", width: "max-content", display: "flex", "flex-direction": "row", "justify-content": "center", "align-items": "center", padding: "4px 10px", "border-radius": "4px", }}>
                                                                    <PlusIcon className={classes.fillGreyStroke} />
                                                                    <Typography pl="5px" fontWeight="500" color="#D8D8D8" fontSize={18} lineHeight="26.91px" display="flex">
                                                                        {/* {t('label.add')} */}
                                                                        Add
                                                                    </Typography>
                                                                </Box>
                                                                : statusUse === false ?
                                                                    max === ratingScale.length || formik.values.type === "scale1_5_decimal" ?
                                                                        <Box sx={{ cursor: "default", width: "max-content", display: "flex", "flex-direction": "row", "justify-content": "center", "align-items": "center", padding: "4px 10px", "border-radius": "4px", }}>
                                                                            <PlusIcon className={classes.fillGreyStroke} />
                                                                            <Typography pl="5px" fontWeight="500" color="#D8D8D8" fontSize={18} lineHeight="26.91px" display="flex">
                                                                                {/* {t('label.add')} */}
                                                                                Add
                                                                            </Typography>
                                                                        </Box>
                                                                        :
                                                                        <Box onClick={addRatingScale} sx={{ cursor: "pointer", width: "max-content", display: "flex", "flex-direction": "row", "justify-content": "center", "align-items": "center", padding: "4px 10px", "border-radius": "4px", }}>
                                                                            <PlusIcon />
                                                                            <Typography pl="5px" fontWeight="500" color="#5DA196" fontSize={18} lineHeight="26.91px" display="flex">
                                                                                {/* {t('label.add')} */}
                                                                                Add
                                                                            </Typography>
                                                                        </Box>
                                                                    :
                                                                    <Box onClick={addRatingScale} sx={{ cursor: "pointer", width: "max-content", display: "flex", "flex-direction": "row", "justify-content": "center", "align-items": "center", padding: "4px 10px", "border-radius": "4px", }}>
                                                                        <PlusIcon />
                                                                        <Typography pl="5px" fontWeight="500" color="#5DA196" fontSize={18} lineHeight="26.91px" display="flex">
                                                                            {/* {t('label.add')} */}
                                                                            Add
                                                                        </Typography>
                                                                    </Box>
                                                            }
                                                        </Box>
                                                        <Box sx={{ overflow: "hidden", height: "100%", transition: "all .8s", "max-height": ratingScale !== undefined && ratingScale !== null && ratingScale.length > 0 ? "999999px" : "0px" }}>
                                                            {ratingScale !== undefined && ratingScale !== null && ratingScale.length > 0 ?
                                                                <Box pb="16px">
                                                                    <Box sx={{ width: "100%", background: "#FAFAFA", }} mt="16px">
                                                                        <Divider />
                                                                        <Box sx={{ height: "50px", padding: "0 25px", display: "flex", "align-items": "center" }}>
                                                                            <Box sx={{ width: "10%" }}>
                                                                                <Typography color="#A0A0A0" sx={{ justifyContent: "center" }} fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">{t('admin.label.scaleLevel')}</Typography>
                                                                            </Box>
                                                                            <Box sx={{ width: "10%" }} pr="20px">
                                                                                <Typography color="#A0A0A0" sx={{ justifyContent: "center" }} fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">{t('admin.label.value')}<Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                                                            </Box>
                                                                            <Box sx={{ width: "40%" }} pr="40px">
                                                                                <Typography color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">{t('admin.inputForm.descriptionEN')}</Typography>
                                                                            </Box>
                                                                            <Box sx={{ width: "40%" }} pr="40px">
                                                                                <Typography color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">{t('admin.inputForm.descriptionTH')}</Typography>
                                                                            </Box>
                                                                            <Box sx={{ width: "60px" }}>
                                                                                <Typography color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">{t('admin.label.action')}</Typography>
                                                                            </Box>
                                                                        </Box>
                                                                        <Divider />
                                                                    </Box>
                                                                    {ratingScale.map((item, idx) => (
                                                                        <Box sx={{ width: "100%" }} >
                                                                            <Box sx={{ height: "calc(100% - 20px)", padding: "10px 25px", display: "flex", "align-items": "center" }}>
                                                                                <Box sx={{ width: "10%" }}>
                                                                                    {start === 1 && scaleUp === 1 ?
                                                                                        <Typography fontWeight="500" color="#404349" sx={{ justifyContent: "center" }} fontSize={14} lineHeight="20.93px" display="flex">{idx + start}</Typography>
                                                                                        : start > 0 ?
                                                                                            <Typography fontWeight="500" color="#404349" sx={{ justifyContent: "center" }} fontSize={14} lineHeight="20.93px" display="flex">{(idx + 2) * scaleUp}</Typography>
                                                                                            :
                                                                                            <Typography fontWeight="500" color="#404349" sx={{ justifyContent: "center" }} fontSize={14} lineHeight="20.93px" display="flex">{idx * scaleUp}</Typography>
                                                                                    }
                                                                                </Box>
                                                                                <Box sx={{ width: "10%" }} pr="20px">
                                                                                    {statusUse ?
                                                                                        <Typography fontWeight="500" color="#404349" sx={{ justifyContent: "center" }} fontSize={14} lineHeight="20.93px" display="flex">{formik.values.ratingScale[idx]?.value}</Typography>
                                                                                        :
                                                                                        <TextField
                                                                                            // error={Boolean(formik.touched.name && formik.errors.name)}
                                                                                            fullWidth
                                                                                            // helperText={formik.touched.name && formik.errors.name}
                                                                                            margin="normal"
                                                                                            name="value"
                                                                                            onBlur={formik.handleBlur}
                                                                                            onChange={e => formikChangeNumber(e, "ratingScale", "value", idx)}
                                                                                            type="text"
                                                                                            value={formik.values.ratingScale[idx]?.value}
                                                                                            variant="outlined"
                                                                                            InputLabelProps={{
                                                                                                shrink: true,
                                                                                            }}
                                                                                            sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                                                                            placeholder={`e.g.${start === 1 && scaleUp === 1 ? idx + start : start > 0 ? (idx + 2) * scaleUp : idx * scaleUp}`}
                                                                                            // classes={{ root: serial !== undefined ? allow_adjust === true ? classes.inputValue : classes.disabledScale : classes.inputValue }}
                                                                                            classes={onSubmit === true ? formik.values.ratingScale[idx]?.value === "" ? { root: classes.inputValueError } : { root: classes.inputValue } : { root: classes.inputValue }}
                                                                                            disabled={serial !== undefined ? allow_adjust === true ? false : true : false}
                                                                                        />
                                                                                    }
                                                                                </Box>
                                                                                <Box sx={{ width: "40%" }} pr="40px">
                                                                                    <TextField
                                                                                        // error={Boolean(formik.touched.name && formik.errors.name)}
                                                                                        fullWidth
                                                                                        // helperText={formik.touched.name && formik.errors.name}
                                                                                        margin="normal"
                                                                                        name="descriptionEN"
                                                                                        onBlur={formik.handleBlur}
                                                                                        onChange={e => formikChangeScale(e, "ratingScale", "descriptionEN", idx)}
                                                                                        type="text"
                                                                                        value={formik.values.ratingScale[idx]?.descriptionEN}
                                                                                        variant="outlined"
                                                                                        InputLabelProps={{
                                                                                            shrink: true,
                                                                                        }}
                                                                                        sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                                                                        placeholder={t('admin.inputForm.placeholder.descriptionEN')}
                                                                                        classes={{ root: serial !== undefined ? allow_adjust === true ? classes.inputTopic : classes.disabledScale : classes.inputTopic }}
                                                                                        multiline
                                                                                        minRows={1}
                                                                                        disabled={serial !== undefined ? allow_adjust === true ? false : true : false}
                                                                                    />
                                                                                </Box>
                                                                                <Box sx={{ width: "40%" }} pr="40px">
                                                                                    <TextField
                                                                                        // error={Boolean(formik.touched.name && formik.errors.name)}
                                                                                        fullWidth
                                                                                        // helperText={formik.touched.name && formik.errors.name}
                                                                                        margin="normal"
                                                                                        name="descriptionTH"
                                                                                        onBlur={formik.handleBlur}
                                                                                        onChange={e => formikChangeScale(e, "ratingScale", "descriptionTH", idx)}
                                                                                        type="text"
                                                                                        value={formik.values.ratingScale[idx]?.descriptionTH}
                                                                                        variant="outlined"
                                                                                        InputLabelProps={{
                                                                                            shrink: true,
                                                                                        }}
                                                                                        sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                                                                        placeholder={t('admin.inputForm.placeholder.descriptionTH')}
                                                                                        classes={{ root: serial !== undefined ? allow_adjust === true ? classes.inputTopic : classes.disabledScale : classes.inputTopic }}
                                                                                        multiline
                                                                                        minRows={1}
                                                                                        disabled={serial !== undefined ? allow_adjust === true ? false : true : false}
                                                                                    />
                                                                                </Box>
                                                                                {statusUse || ratingScale.length === 1 || formik.values.type === "scale1_5_decimal" ?
                                                                                    <Box sx={{ width: "60px", "padding-left": "10px", height: "20px" }} my="14.5px">
                                                                                        <Delete style={{ cursor: "default" }} className={classes.fillGrey} />
                                                                                    </Box>
                                                                                    : statusUse === false ?
                                                                                        ratingScale.length === 1 || formik.values.type === "scale1_5_decimal" ?
                                                                                            <Box sx={{ width: "60px", "padding-left": "10px", height: "20px" }} my="14.5px">
                                                                                                <Delete style={{ cursor: "default" }} className={classes.fillGrey} />
                                                                                            </Box>
                                                                                            :
                                                                                            <Box sx={{ width: "60px", "padding-left": "10px", height: "20px" }} my="14.5px">
                                                                                                <Delete style={{ cursor: "pointer" }} onClick={e => formikDelete(ratingScale, "ratingScale", setRatingScale, idx)} />
                                                                                            </Box>
                                                                                        :
                                                                                        <Box sx={{ width: "60px", "padding-left": "10px", height: "20px" }} my="14.5px">
                                                                                            <Delete style={{ cursor: "pointer" }} onClick={e => formikDelete(ratingScale, "ratingScale", setRatingScale, idx)} />
                                                                                        </Box>
                                                                                }
                                                                            </Box>
                                                                            <Divider />
                                                                        </Box>
                                                                    ))
                                                                    }
                                                                </Box>
                                                                :
                                                                null
                                                            }
                                                        </Box>
                                                    </Box>
                                                    {onSubmit === true ? ratingScale.length > 0 ? ratingScale.length > 0 && checkDataOne(formik.values.ratingScale) === false ?
                                                        <Typography fontWeight="400" color="#d32f2f" fontSize="0.75rem" lineHeight="1.66" sx={{ position: "absolute", "margin-top": "3px", "margin-right": "14px", "margin-bottom": "0", "margin-left": "14px" }}>{t('admin.inputForm.msgError.nameEN')}</Typography>
                                                        : null : null : null}
                                                </Box>
                                            </Box>
                                            : null
                                        }
                                        {statusUse ?
                                            <Box pt="17px" sx={{ width: "calc(100% - 80px)", margin: "0 40px", ".MuiFormControl-root": { "margin-top": "7px" }, display: "flex", "align-items": "center", ".MuiCheckbox-root": { padding: "0" } }}>
                                                <Checkbox onChange={e => onCheckDefault()} checked={defaults} disabled={serial !== undefined ? allow_adjust === true ? false : true : false} />
                                                <Typography pl="15px" color="#404349" fontSize={16} lineHeight="24px" >Update Scale Level Description to existing setups and forms using this scaling master.</Typography>
                                            </Box>
                                            : null
                                        }
                                    </Box>
                                    <Box mt="30px">
                                        <Box display="flex" flexDirection="row-reverse">
                                            <Box sx={{ width: "100px" }}>
                                                <Button disabled={save === true ? edit === false ? true : false : true} onClick={handleSubmit} color="primary" variant="contained" fullWidth sx={{ textTransform: "none" }}>
                                                    {serial !== undefined ? t(`label.save`) : t(`label.create`)}
                                                    {/* <Typography fontSize={18} lineHeight="29px" fontWeight="500" color="#FFF">Create</Typography> */}
                                                </Button>
                                            </Box>
                                            <Box mr={2} sx={{ width: "100px" }}>
                                                <Button color="black" variant="outlined" fullWidth onClick={handleCancel} sx={{ textTransform: "none" }}>
                                                    {/* <Typography fontSize={18} lineHeight="29px" fontWeight="500" color="#6B6B6B">Cancel</Typography>  */}
                                                    {t('label.cancel')}
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                    <SimpleDialog
                        open={isSuccessAddDialogOpen}
                        doDirect={() => handleDirect()}
                        setValue={openSuccessAddDialog}
                        text={serial !== undefined ? t(`admin.label.scalingMasterEditSuccessfully`) : t(`admin.label.scalingMasterCreatedSuccessfully`)}
                        page={true}
                    />
                    <MessageDialog
                        open={openFailedMessageDialog}
                        setValue={handleCloseFailedMessageDialog}
                        type="fail"
                        title={t(`dialog.label.fail`)}
                        text={errorText + t(`dialog.label.tryAgain`)}
                    />
                    <ConfirmDialog open={discardDialog} warning={true} doConfirm={() => handleDiscardChangeConfirm()} setValue={() => handleDiscardDialog(false)} title={t('label.confirmationOfDiscard')} text={t('label.youSureDiscardChange')} />
                    <ConfirmDialog open={checkDialog} warning={true} twoText={true} doConfirm={() => handleCheckChangeConfirm()} setValue={() => handleCheckDialog(false)} title={defaults ? t('admin.label.confirmationCheck') : t('admin.label.confirmationUnCheck')} text={defaults ? t('admin.label.areYouSureCheck') : t('admin.label.areYouSureUnCheck')} />
                </Container>
            </Box >
        </>
    )
};
export default ScalingMasterCreate;
